import React from "react";

const EditSignature = () => {
  return (
    <div>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="22"
        height="19"
        viewBox="0 0 22 19"
        fill="none"
      >
        <path
          d="M17.4079 3.66374C17.5423 3.53888 17.6127 3.34267 17.6127 3.1524C17.6127 2.96213 17.5423 2.78376 17.3887 2.6589L15.117 0.637304C14.9634 0.494604 14.7714 0.429199 14.5667 0.429199C14.3619 0.429199 14.1891 0.506495 14.0355 0.649196L12.8389 1.81458L16.1921 4.82913L17.4079 3.66374Z"
          fill="#0075AA"
        />
        <path
          d="M6.43995 11.3752L10.5547 10.3584L15.1493 5.8693L11.7705 2.83691L7.17587 7.34387L6.24798 11.2146C6.23518 11.3395 6.28637 11.3871 6.43995 11.3752ZM6.99029 10.5308L7.55342 8.15845L9.60759 10.0076L7.08628 10.6438C7.00949 10.6438 6.97109 10.6081 6.99029 10.5308Z"
          fill="#0075AA"
        />
        <path
          d="M10.2667 13.6826C9.7164 13.7778 8.9293 14.0037 8.0206 14.2713C7.13111 14.5269 6.13282 14.8123 5.19213 15.0204C3.61792 15.3712 2.67083 15.3058 2.22928 15.0026C2.12689 14.9372 2.0757 14.8421 2.0437 14.7469C2.0117 14.6221 2.0437 14.4734 2.11409 14.301C2.38926 13.6826 3.17637 13.0286 4.37943 12.6778C4.78898 12.5648 5.01295 12.1545 4.89137 11.7681C4.76978 11.3875 4.32823 11.1794 3.91228 11.2924C2.23568 11.7681 1.08381 12.7729 0.655063 13.7599C0.469484 14.188 0.41829 14.634 0.520678 15.0323C0.623066 15.4604 0.879036 15.8469 1.30779 16.1442C2.0821 16.6674 3.46433 16.8637 5.54409 16.3999C6.53598 16.1799 7.56626 15.8885 8.45575 15.621C9.16607 15.4069 9.80599 15.2285 10.2667 15.1334C10.6123 14.5329 11.0219 13.9918 11.4954 13.5043C11.0858 13.5518 10.6763 13.6113 10.2667 13.6826Z"
          fill="#0075AA"
        />
        <path
          d="M16.417 11.875C14.1443 11.875 12.2034 13.2886 11.417 15.2841C12.2034 17.2795 14.1443 18.6932 16.417 18.6932C18.6897 18.6932 20.6306 17.2795 21.417 15.2841C20.6306 13.2886 18.6897 11.875 16.417 11.875ZM16.417 17.5568C15.1624 17.5568 14.1443 16.5386 14.1443 15.2841C14.1443 14.0295 15.1624 13.0114 16.417 13.0114C17.6715 13.0114 18.6897 14.0295 18.6897 15.2841C18.6897 16.5386 17.6715 17.5568 16.417 17.5568ZM16.417 13.9205C15.6624 13.9205 15.0534 14.5295 15.0534 15.2841C15.0534 16.0386 15.6624 16.6477 16.417 16.6477C17.1715 16.6477 17.7806 16.0386 17.7806 15.2841C17.7806 14.5295 17.1715 13.9205 16.417 13.9205Z"
          fill="#0075AA"
        />
      </svg>
    </div>
  );
};

export default EditSignature;
